import HttpException from 'exceptions/HttpException'

export default class HttpNotFoundException extends HttpException {
  constructor(message, ...args) {
    super('Not Found', message, ...args)

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, HttpNotFoundException)
    }

    this.code = 404
  }
}
